import { render, staticRenderFns } from "./CardExcerpt.vue?vue&type=template&id=3dd93577"
import script from "./CardExcerpt.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardExcerpt.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports